module.exports = __webpack_public_path__ + "media/images/bad-c248d368.svg";